export const actions = {
  async nuxtServerInit() {},
};
